import { Component, Input, OnInit } from '@angular/core';
import * as Highcharts from 'highcharts';

import { HttpClient } from '@angular/common/http';
import { BarserviceService } from '../../barservice.service'
import { Observable } from 'rxjs';
@Component({
  selector: 'app-barchart17',
  templateUrl: './barchart17.component.html',
  styleUrls: []
})
export class Barchart17Component implements OnInit {
  chart: any;
  event: any;
  datalabel: any = false;
  Highcharts: typeof Highcharts = Highcharts;
  seriesData: any = [];
  changeValue: any;
  properties: any;
  changeValueSeries: any;
  significance: any;
  changeValueSeriesUSA: any;
  significanceUSA: any;
  data: any;
  barChartData: any;
  jsonData: any;
  sampleSize: any;
  min: any;
  max: any;
  significance2: any;
  categories: any;
  colorIndex: any = 0;
  maxDataPoints: any=5;
  maxSeries: any;
  maxSeriesScreen: any;
    pointWidthSize: any;
    categoryImages: any;
  constructor(private http: HttpClient, private barService: BarserviceService) { }
  @Input() id:any;
  @Input() height:any="44%";
  ngOnInit(): void {
    this.http.get<any>('assets/Data/clusterBarData.json').subscribe((data: any) => {
      this.jsonData = data;
      this.data = data[0];
      this.barChartData = data[0]["data"];
      this.properties = data[0]["properties"][0];

      this.getBarChart('chart-container'+this.id, this.seriesData, this.properties);
    });

  }
  customization(): Observable<any[]> {
    return this.barService.HorizontalClusterBarcustomizationList();
  }
  //make the function accessSeriesValues dynamic to accept distinct series name and data values for each series

  accessSeriesValues(seriesData: any, islowSample: any) {
    const seriesObjects: any = {};
    const categories: string[] = [];
    const signi: any[] = [];
    const signi2: any[] = [];
    const changes: any[] = [];
    const sampleSizeValues: any[] = [];

    // Find unique series names
    const uniqueSeriesNames = [...new Set(this.jsonData[0].data.map((series: { [x: string]: any; }) => series["Series Name"]))];
    this.maxSeries = uniqueSeriesNames.length;
    if (this.maxSeries > 15) {
      this.maxSeriesScreen = 1;
      this.pointWidthSize = this.height!="100%"?10:7;
    } else if (this.maxSeries > 9) {
      this.maxSeriesScreen = 2;
      this.pointWidthSize =  this.height!="100%"?8:5;
    }
    else if (this.maxSeries > 5 && this.maxSeries<15) {
      this.maxSeriesScreen = 3;
      this.pointWidthSize =  this.height!="100%"?7:4;
    }
    else {
      this.maxSeriesScreen = 4;
      if(this.height=="100%"){
        this.pointWidthSize=5
      }
    }
    uniqueSeriesNames.forEach(seriesName => {
      const seriesData = this.jsonData[0].data.filter((series: { [x: string]: unknown; }) => series["Series Name"] === seriesName);
      let iterationCount = 0;

      seriesData.forEach((series: { [x: string]: string; Label: any; }) => {
        const numericValue = (series["Value"] == null) ? 0 :Number(parseFloat(series['Value']).toFixed(this.properties.decimalRoundOff));
        const label = series.Label; // 'Label' property directly accessed
        const change = parseFloat(series["Change value vs PY"]);
        const significance = parseFloat(series["Significance"]);
        const significance2 = parseFloat(series["Significance2"]);
        const category = series["Category Name"];
        const sampleSize = parseFloat(series["Sample size"]);
        const seriesName = series["Series Name"];
        const roundedValue = series["Rounded Value"];
        const tooltip = ""; // Initialize tooltip

        let finalValue = !islowSample ? numericValue : (sampleSize > this.barService.sampleSizeConstant ? numericValue : 0);

        if (!seriesObjects[seriesName]) {
          seriesObjects[seriesName] = {
            name: seriesName,
            categoryName: category,
            data: [],
            label: [], // Initialize as an array
            changeValue: [], // Initialize as an array
            sampleSize: [], // Initialize as an array
            significance: [], // Initialize as an array
            significance2: [], // Initialize as an array
            roundedValue: [], // Initialize as an array
            visible: true,
            tooltip: [] // Initialize tooltip
          };
        }

        seriesObjects[seriesName].sampleSize.push(sampleSize);
        seriesObjects[seriesName].data.push(finalValue);
        seriesObjects[seriesName].label.push(label); // Push label value to array
        seriesObjects[seriesName].changeValue.push(change);
        seriesObjects[seriesName].significance.push(significance);
        seriesObjects[seriesName].significance2.push(significance2);
        seriesObjects[seriesName].roundedValue.push(roundedValue);
        seriesObjects[seriesName].tooltip.push(tooltip); // Push tooltip value to array
        if (!categories.includes(category)) {
          categories.push(category);
        }

        iterationCount++;
      });

    });

    const firstSeriesName = uniqueSeriesNames.length > 0 ? uniqueSeriesNames[0] : null
    const seriesData1 = this.jsonData[0].data.filter((series: { [x: string]: unknown; }) => series["Series Name"] === firstSeriesName);

    this.categoryImages = seriesData1.map((series: { [x: string]: string; }) => series["Category Image"]);

    this.categories = categories;
    let i = 0;
    this.seriesData = Object.values(seriesObjects).map((item: any) => {
      return {
        name: item.name,
        data: item.data,
        label: item.label,
        //pointPadding: 2.3,
        //groupPadding: 0.3,
        zIndex: 2,

        pointWidth: this.pointWidthSize,
        color: this.properties.showPattern ? this.getPatternForImage(this.barService.patternImages[i++]) : this.properties.gradientBarColor ? this.barService.linearGradients[i++] : this.barService.color1[i++],
               roundedValue:item.roundedValue,

        changeValue: item.changeValue,
        significance: item.significance,
        significance2: item.significance2,
        sampleSize: item.sampleSize,
        visible: item.visible,
        showInlegend: item.showInLegend,
        tooltip: {
          enabled: true
        }
      };
    });
    let maxValue = Number.MIN_VALUE; // Initialize with the smallest possible value
    let minValue = Number.MAX_VALUE; // Initialize with the largest possible value

    // Loop through the collected data
    for (const seriesName in seriesObjects) {
      const seriesData = seriesObjects[seriesName];

      // Check if the series has data
      if (seriesData.data.length > 0) {
        const seriesMaxValue = Math.max(...seriesData.data);
        const seriesMinValue = Math.min(...seriesData.data);

        // Update overall max and min values
        maxValue = Math.max(maxValue, seriesMaxValue);
        minValue = Math.min(minValue, seriesMinValue);
      }
    }
    this.max = maxValue + Math.ceil(maxValue * 0.10);
    this.min = minValue + Math.ceil(minValue * 0.10);
  }



  patternselect(ispattern: boolean) {
    this.properties.showPattern = ispattern
    this.accessSeriesValues(this.jsonData, this.properties.datalabelStyle == "ls");
    this.getBarChart('chart-container', this.seriesData, this.properties);
    ;
  }

  // commonfunc(event: any, customization: string, options: any) {
  //   this.event = event;
  //   this.properties = this.barService.commonFunc(customization, event, this.properties)
  //   //this.accessSeriesValues(this.properties.lowSample);
  //   this.getBarChart('chart-container', this.seriesData, this.properties);
  // }

  applycustomization(event: any, item: string) {
    this.event = event;
    //choose the appropriate customization
    this.barService.applycustomization(event,item, this.properties)
    this.getBarChart('chart-container', this.seriesData, this.properties);
  }
  getBarChart(containerid: string, seriesData: any, properties: any) {
    localStorage.setItem("properties", JSON.stringify(this.properties));
    this.accessSeriesValues(this.seriesData, this.properties.datalabelStyle == "ls");
    let serviceBar = this.barService;


    const updatedCategories = this.categoryImages;

    const defaultCategories = this.categories;



    const options: Highcharts.Options = {
      chart: {
        type: 'bar',
        backgroundColor: this.properties.darkTheme
          ? this.barService.darkThemeBackgroundColor
          : this.barService.defaultThemeBackgroundColor,
        style: {
          fontFamily: this.barService.textfont,
          fontSize: '0.7rem',
          color: this.properties.darkTheme
            ? this.barService.darkThemeTextColor
            : this.barService.defaultThemeTextColor,
          // height:200
        },
        events: {
          load: function () {
            const chart = this;
            // window.addEventListener('resize', function () {
            //   chart.reflow();
            // });
            //#region wheel scroll
            const container = chart.container;
            const xAxis = chart.xAxis[0];

            function onWheel(e: any) {
              e = e || window.event;
              e.preventDefault();

              // Normalize wheel delta
              let delta = e.wheelDelta ? e.wheelDelta : -e.deltaY;
              delta = delta > 0 ? -1 : 1; // reverse for natural scrolling

              const extremes = xAxis.getExtremes();
              const step = 1; // how many categories to scroll at a time

              let newMin = extremes.min + delta * step;
              let newMax = extremes.max + delta * step;

              // Bound checks
              if (newMin < extremes.dataMin) {
                newMin = extremes.dataMin;
                newMax = newMin + (extremes.max - extremes.min);
              }
              if (newMax > extremes.dataMax) {
                newMax = extremes.dataMax;
                newMin = newMax - (extremes.max - extremes.min);
              }

              xAxis.setExtremes(newMin, newMax, true, false);
            }

            container.addEventListener('wheel', onWheel, {
              passive: false,
            });
            //#endregion
          },
        },
      },
      title: {
        text: '',
        align: this.properties.chartTitlePosition,
        style: {
          color: this.properties.darkTheme
            ? this.barService.darkThemeTextColor
            : this.barService.defaultThemeTextColor,
          marginleft: '4%',
          fontSize: '2em',
          fontFamily: this.barService.textfont,
        },
      },
      subtitle: {},
      exporting: {
        enabled: false,
      },
      legend: this.barService.customizeLegend(
        this.chart,
        this.properties.showLegend,
        this.properties.legendPosition,
        this.properties
      ),
      xAxis: {
        categories: defaultCategories,

        min: 0,
        max: this.maxSeriesScreen,

        scrollbar: {
          enabled: defaultCategories.length > this.maxDataPoints ? true : false,
          height: 6, // Adjust the height of the scrollbar as needed
          barBackgroundColor: '#7f7f7f',//#0060FF,
          barBorderRadius: 5,
          barBorderWidth: 0,
          barBorderColor: this.properties.darkTheme
            ? this.barService.darkThemeBackgroundColor
            : this.barService.defaultThemeBackgroundColor,
          buttonBackgroundColor: this.properties.darkTheme
            ? this.barService.darkThemeBackgroundColor
            : this.barService.defaultThemeBackgroundColor,
          buttonBorderWidth: 0,
          buttonArrowColor: this.properties.darkTheme
            ? this.barService.darkThemeBackgroundColor
            : this.barService.defaultThemeBackgroundColor,
          buttonBorderRadius: 5,
          rifleColor: 'none',
          trackBackgroundColor: this.properties.darkTheme
            ? this.barService.darkThemeBackgroundColor
            : this.barService.defaultThemeBackgroundColor,
          trackBorderWidth: 0,
          trackBorderColor: 'black',
          trackBorderRadius: 5,
        },
        showEmpty: false,
        labels: {
          useHTML: true,
          style: {
            color: this.properties.darkTheme
              ? this.barService.darkThemeTextColor
              : this.barService.defaultThemeTextColor,
          },
          formatter: function (
            this: Highcharts.AxisLabelsFormatterContextObject
          ) {
            if (properties.axisImage) {
              let index = defaultCategories.indexOf(String(this.value));

              const category =
                serviceBar.baseImgPath + updatedCategories[index] + '.png';

              if (category) {
                return (
                  '<span style="display: inline-block; width: 2em; height: 2em; background: url(' +
                  category +
                  ') no-repeat center center; background-size: cover;"></span>'
                );
              } else {
                return '<span>No Image</span>';
              }
            } else {
              return String(this.value);
            }
          },

          rotation: this.barService.axisLabelOrientation(
            this.properties.axisLabelOrientation
          ), // Rotate labels by -90 degrees (or any other desired angle)
        },
      },
      yAxis: {
        gridLineWidth: this.properties.gridlines ? 1 : 0,
        max: this.max,
        min: this.min,
        margin: 1,
        plotLines: [
          {
            value: 0,
            width: 1,
          },
        ],

        accessibility: {
          rangeDescription: 'Range: 0 to 100', // Update the accessibility range description
        },
        labels: {
          format:
            this.properties.datalabelFormat == 'percentage'
              ? '{value}%'
              : '{value}',
          style: {
            color: this.properties.darkTheme
              ? this.barService.darkThemeTextColor
              : this.barService.defaultThemeTextColor,
          },
        },
        title: {
          text: '', // Set an empty string to hide the yAxis title
        },
      },
      tooltip: {
        enabled: true,
        borderWidth: 0,
        useHTML: true,
        // shape: properties.toolTipStyle == "style1" ? 'square' : 'callout',
        shadow: false,
        backgroundColor: 'rgba(0,0,0,0)',

        formatter: function (this: any) {
          if (this.series.name === 'Marker1') return false;
          let isDefaultTooltip = properties.toolTipStyle;
          const dotColor = serviceBar.color1[this.point.x]; // Get the series color
          const backgroundcolor = properties.darkTheme ? '#b3b3b3' : '#f5f5f5';
          const backgroundcolor2 = properties.darkTheme ? '#dddddd' : 'white';
          const text = properties.showDataLabel
            ? this.series.userOptions.tooltip[this.point.x]
            : this.y;
          if (isDefaultTooltip == 'style1') {
            const commonContent =
              `<div style="border-left: 5px solid ${dotColor}; border-bottom: 5px solid ${dotColor}; z-index: 100; padding: 2%; border-radius: 5px; margin: 0; background-color: ${backgroundcolor2};">` +
              `<span style="display: block; text-align: center; color: ${dotColor}; font-weight: bold; font-size: 0.8rem;">Tooltip Title</span>` +
              `<span><strong>Series Name:</strong></span> ${this.series.name}<br>` +
              `<span><strong>Category Name:</strong></span> ${
                defaultCategories[this.point.x]
              }<br>` +
              `<span><strong>Value:</strong></span> ${text}`;

            return commonContent + '</div>';
          } else {
            const content =
              `<div style="background-color: ${backgroundcolor}; padding: 10%; align-items: center; border: 1px solid ${dotColor}; width:120%">` +
              `<div style="width: 1em; height: 1em; background-color: ${dotColor}; border-radius: 50%; margin-right: 5%;"> </div>` +
              ` ${this.series.name}` +
              `<div style="display: block; margin-top: 1%;"><strong>Value:</strong> ${text}</div>`;

            return content + '</div>';
          }
        },
      },
      credits: {
        enabled: false,
      },
      plotOptions: {
        series: {
          borderWidth: 0,
          animation: false,
          allowPointSelect: false,
          states: {
            hover: {
              enabled: false,
            },
            inactive: {
              enabled: false,
            },
            select: {
              enabled: false,
            },
          },
          //animation: this.properties.dataLabelPositionPPT == 'Inside Base' || this.properties.dataLabelPositionPPT == 'Center' || this.properties.dataLabelPositionPPT == 'Inside End' || this.properties.dataLabelPositionPPT == 'Outside End' ? false : true,
        },
        bar: {
          stacking: undefined,
          shadow: this.properties.shadow
            ? {
                color: this.barService.shadowColor,
                offsetX: 1,
                offsetY: 1,
                opacity: 0.5,
                width: 6,
              }
            : false,
          pointPadding: 0.25,
          groupPadding: 0.1,

          dataLabels: {
            style: {
              backgroundColor: this.barService.transparentBackground,

              textOutline: 'none',

              color: this.properties.darkTheme
                ? this.properties.dataLabelColor === 'default'
                  ? 'white'
                  : this.properties.dataLabelColor ||
                    this.barService.darkThemeTextColor
                : this.properties.dataLabelColor === 'default'
                ? 'black'
                : this.properties.dataLabelColor ||
                  this.barService.defaultThemeTextColor,
              fontSize: this.properties.dataLabelSize,
              fontWeight: 'normal',
            },

            crop: false,
            enabled: this.properties.showDataLabel,

            inside: true,

            rotation: this.properties.datalabelOrientation,

            align:
              this.properties.dataLabelPosition == 'middle'
                ? 'center'
                : this.properties.dataLabelPosition == 'top'
                ? 'right'
                : 'left',
            allowOverlap:
              this.properties.dataLabelOverlap == 'false' ? false : true,

            formatter: function (this: any) {
              if (properties.datalabelStyle == 'significance + changeVs') {
                let text =
                  this.series.userOptions.roundedValue[this.point.x] != null
                    ? this.y +
                      (properties.datalabelFormat == 'percentage' ? '%' : '')
                    : serviceBar.nullValueText;
                let changeText =
                  this.series.userOptions.changeValue[this.point.x];
                let sig = this.series.userOptions.significance[this.point.x];
                let s =
                  sig > 0
                    ? serviceBar.upwardTriangle
                    : sig < 0
                    ? serviceBar.downwardTriangle
                    : '';
                let sigcolor =
                  sig > 0
                    ? serviceBar.highSignificance
                    : sig < 0
                    ? serviceBar.lowSignificance
                    : '';
                if (parseFloat(changeText) > 0) {
                  changeText = '+' + changeText;
                }
                let finalText =
                  '<span>' +
                  '<span>' +
                  text +
                  '</span>' +
                  (this.series.userOptions.roundedValue[this.point.x] != null &&
                  changeText
                    ? '<span>&nbsp' +
                      '<span style="font-size: ' +
                      serviceBar.changeValueFontSize +
                      ';color:' +
                      (properties.darkTheme
                        ? serviceBar.darkThemeTextColor
                        : serviceBar.defaultThemeTextColor) +
                      '; ">(' +
                      changeText +
                      ')</span>&nbsp;' +
                      '<span style="color:' +
                      sigcolor +
                      ';">' +
                      s +
                      '</span>'
                    : '') +
                  '</span>';

                this.series.userOptions.tooltip[this.point.x - 1] = finalText;
                return finalText;
              }
              if (properties.datalabelStyle == 'change') {
                let text =
                  this.series.userOptions.roundedValue[this.point.x] != null
                    ? this.y +
                      (properties.datalabelFormat == 'percentage' ? '%' : '')
                    : serviceBar.nullValueText;
                let changeText =
                  this.series.userOptions.changeValue[this.point.x];

                let finalText =
                  '<span>' +
                  text +
                  '  ' +
                  (this.series.userOptions.roundedValue[this.point.x] != null &&
                  changeText
                    ? '<span>&nbsp' +
                      '<span style="font-size: ' +
                      serviceBar.changeValueFontSize +
                      ';color:' +
                      (properties.darkTheme
                        ? serviceBar.darkThemeTextColor
                        : serviceBar.defaultThemeTextColor) +
                      '; ">(' +
                      changeText +
                      ')</span>&nbsp;' +
                      '</span>'
                    : '');
                this.series.userOptions.tooltip[this.point.x - 1] = finalText;

                return finalText;
              }

              if (properties.datalabelStyle == 'ls') {
                let text =
                  parseFloat(this.series.userOptions.sampleSize[this.point.x]) >
                  serviceBar.sampleSizeConstant
                    ? this.series.userOptions.roundedValue[this.point.x] != null
                      ? this.y +
                        (properties.datalabelFormat == 'percentage' ? '%' : '')
                      : serviceBar.nullValueText
                    : serviceBar.lowSampleText;
                let finalText =
                  '<b>' + text + '</b> ' + '<span style="opacity: 0.5"></span>';
                this.series.userOptions.tooltip[this.point.x - 1] = finalText;

                return finalText;
              }
              if (properties.datalabelStyle == 'significance') {
                let text =
                  this.series.userOptions.roundedValue[this.point.x] != null
                    ? this.y +
                      (properties.datalabelFormat == 'percentage' ? '%' : '')
                    : serviceBar.nullValueText;
                let sig = this.series.userOptions.significance[this.point.x];
                let s =
                  sig > 0
                    ? serviceBar.upwardTriangle
                    : sig < 0
                    ? serviceBar.downwardTriangle
                    : '';
                let sigcolor =
                  sig > 0
                    ? serviceBar.highSignificance
                    : sig < 0
                    ? serviceBar.lowSignificance
                    : '';

                let finalText =
                  '<span >' +
                  text +
                  (this.series.userOptions.roundedValue[this.point.x] != null
                    ? '&nbsp<span style="color:' +
                      sigcolor +
                      ';">' +
                      s +
                      '</span>'
                    : '') +
                  '</span>';
                this.series.userOptions.tooltip[this.point.x - 1] = finalText;
                return finalText;
              }
              if (properties.datalabelStyle == 'datalabel') {
                let text =
                  this.series.userOptions.roundedValue[this.point.x] != null
                    ? this.y +
                      (properties.datalabelFormat == 'percentage' ? '%' : '')
                    : serviceBar.nullValueText;
                this.series.userOptions.tooltip[this.point.x - 1] = text;
                return '<span >' + text + '</span>';
              }
              if (properties.datalabelStyle == 'default') {
                let text =
                  this.series.userOptions.roundedValue[this.point.x] != null
                    ? this.y +
                      (properties.datalabelFormat == 'percentage' ? '%' : '')
                    : serviceBar.nullValueText;
                this.series.userOptions.tooltip[this.point.x - 1] = text;
                return '<span >' + text + '</span>';
              }

              if (properties.datalabelStyle == 'significance2') {
                let text =
                  this.series.userOptions.roundedValue[this.point.x] != null
                    ? this.y +
                      (properties.datalabelFormat == 'percentage' ? '%' : '')
                    : serviceBar.nullValueText;
                let changeText =
                  this.series.userOptions.changeValue[this.point.x];
                let sig = this.series.userOptions.significance[this.point.x];
                let sig1 = this.series.userOptions.significance2[this.point.x];
                let sColor =
                  sig > 0
                    ? serviceBar.highSignificance
                    : sig < 0
                    ? serviceBar.lowSignificance
                    : '';
                let s =
                  sig > 0
                    ? serviceBar.upwardTriangle
                    : sig < 0
                    ? serviceBar.downwardTriangle
                    : '';

                let changeColor =
                  sig1 > 0
                    ? serviceBar.lowSignificance
                    : sig1 < 0
                    ? serviceBar.highSignificance
                    : properties.darkTheme
                    ? serviceBar.darkThemeTextColor
                    : serviceBar.defaultThemeTextColor;

                if (parseFloat(changeText) > 0) {
                  changeText = '+' + changeText;
                }

                let finalText =
                  '<span>' +
                  text +
                  (this.series.userOptions.roundedValue[this.point.x] != null &&
                  changeText
                    ? '&nbsp<span style="color:' +
                      (properties.darkTheme
                        ? serviceBar.darkThemeTextColor
                        : serviceBar.defaultThemeTextColor) +
                      ' "> ' +
                      '<span style="font-size:' +
                      serviceBar.changeValueFontSize +
                      '; color:' +
                      changeColor +
                      ';">(' +
                      changeText +
                      ')</span>&nbsp' +
                      '<span style="color:' +
                      sColor +
                      ';">' +
                      s +
                      '</span>'
                    : '') +
                  '</span>';
                this.series.userOptions.tooltip[this.point.x - 1] = finalText;
                return finalText;
              }

              return this.series.userOptions.roundedValue[this.point.x] != null
                ? this.y
                : serviceBar.nullValueText;
            },
          },
        },
      },
      series: this.seriesData,
    };
    const containerEl = document.getElementById('chart-container'+this.id);
    if (!containerEl) { return; }
    Highcharts.chart(containerEl, options);

  }
  userselectedproperties() {

    // this.jsonData['data'] = this.jsonData['data'].slice(0, 10);
    this.data["properties"][0] = this.properties;
    return JSON.stringify(this.data).toString();
  }
  getPatternForImage(imageUrl: any) {
    return {
      pattern: {
        image: imageUrl,
        aspectRatio: 9 / 4
      }
    };
  }

  ngOnDestroy(): void {
    if (this.chart) {
      this.chart.destroy();
      this.chart = null;
    }
  }
}
